export class GetOperationObjectsParams {
  operation_type_id: string;
  operation_step_index: number;
  context_objects: any[];
  selected_objects: any[];
  get_edit_object: any;
  parent_object_id: string;
  select_field: string;
}
